
document.addEventListener("DOMContentLoaded", function(event) {
  if (document.getElementsByClassName("review-swiper").length) {
    const swiper = new Swiper('.review-swiper', {
      spaceBetween: 20,
      slidesPerView: 3,
      loop: true,
      dynamicBullets: true,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-next',
      },
      breakpoints: {
        1: {
          slidesPerView: 1,
          spaceBetweenSlides: 0,
        },
        600:{
          slidesPerView: 2,
          spaceBetweenSlides: 0,
        },
        1001: {
          slidesPerView: 3,
          spaceBetweenSlides: 30,
        },
      },
    });
  };
  if (document.getElementsByClassName("job-swiper").length) {
    const jobswiper = new Swiper('.job-swiper', {
      spaceBetween: 20,
      slidesPerView: 3,
      loop: true,
      dynamicBullets: true,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-next',
      },
      breakpoints: {
        1: {
          slidesPerView: 1,
          spaceBetweenSlides: 0,
        },
        600:{
          slidesPerView: 2,
          spaceBetweenSlides: 0,
        },
        500: {
          slidesPerView: 1,
          spaceBetweenSlides: 0,
        },
        1001: {
          slidesPerView: 3,
          spaceBetweenSlides: 30,
        },
      },
    });
  };
});